import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { Customer } from '@klickdata/core/customer';
import { AppScope } from '@klickdata/core/resource';
import { User } from '@klickdata/core/user';

@Component({
    selector: 'app-quick-access-users-select',
    templateUrl: './quick-access-users-select.component.html',
    styleUrls: ['./quick-access-users-select.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuickAccessUsersSelectComponent implements OnInit {
    public assignForm: FormGroup;
    AppScope = AppScope;

    constructor(
        public bottomSheetRef: MatBottomSheetRef<QuickAccessUsersSelectComponent>,
        @Inject(MAT_BOTTOM_SHEET_DATA) public data: { route: string; customer: Customer; authUser: User },
        protected fb: FormBuilder
    ) {
        this.assignForm = this.fb.group({
            id: [],
            route: [],
            sync_all_users: [],
            users_attach: [],
            users_detach: [],
            sync_all_groups: [],
            groups_attach: [],
            groups_detach: [],
            sync_all_teams: [],
            teams_attach: [],
            teams_detach: [],
        });
    }

    ngOnInit() {
        this.assignForm.patchValue({ route: this.data.route, id: this.data.customer.id });
    }

    public submit() {
        if (
            this.assignForm.value.users_attach?.length ||
            this.assignForm.value.users_detach?.length ||
            this.assignForm.value.groups_attach?.length ||
            this.assignForm.value.groups_detach?.length ||
            this.assignForm.value.teams_attach?.length ||
            this.assignForm.value.teams_detach?.length ||
            this.assignForm.value.sync_all_users !== null ||
            this.assignForm.value.sync_all_groups !== null ||
            this.assignForm.value.sync_all_teams !== null
        ) {
            const cleanedValue = Object.fromEntries(
                Object.entries(this.assignForm.value).filter(([, v]) => v !== null && v !== undefined)
            );
            this.bottomSheetRef.dismiss(cleanedValue);
        }
    }
}
